import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { WeeklyItem } from "@/types/schedule";

interface ProjectedScheduleResponse {
  from_date: string;
  to_date: string;
  items: WeeklyItem[];
}

export function useTeacherProjectedSchedule(
  teacherCode: string | undefined,
  fromDateISO: string,
  toDateISO: string,
) {
  return useQuery({
    queryKey: ["teacher-projected-schedule", teacherCode, fromDateISO, toDateISO],
    enabled: Boolean(teacherCode && fromDateISO && toDateISO),
    staleTime: 30 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_teacher_projected_schedule" as never, {
        _teacher_code: teacherCode,
        _from_date: fromDateISO,
        _to_date: toDateISO,
      } as never);
      if (error) throw error;
      return (data ?? { from_date: fromDateISO, to_date: toDateISO, items: [] }) as ProjectedScheduleResponse;
    },
  });
}
